/**
 * Cart count sync for hp-header + bundled line removal (LensAdvizor).
 * Updated 2026-06-26: lens replacement cart visibility + orphan safety.
 */
(function () {
  function getItemProperties(item) {
    return item && item.properties ? item.properties : {};
  }

  function getBundleId(item) {
    var props = getItemProperties(item);
    var keys = ['_uuid', '_unique_identifier', '_xBundleId', '_bundleId'];
    for (var i = 0; i < keys.length; i++) {
      if (props[keys[i]]) return String(props[keys[i]]).trim();
    }
    return '';
  }

  function isLensReplacementParent(item) {
    if (!item) return false;
    var props = getItemProperties(item);
    if (props._productType === 'addon') return false;

    var handle = String(item.handle || '');
    if (/^lens-replacement-/.test(handle)) return true;

    var url = String(item.url || '');
    if (url.indexOf('lens-replacement') !== -1) return true;

    var title = String(item.product_title || item.title || '');
    if (title.indexOf('Lens Replacement') !== -1) return true;

    if (props._model || props._color_code || props._width) return true;

    return false;
  }

  function cartHasLensReplacementOrder(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;

    for (var i = 0; i < cart.items.length; i++) {
      if (isLensReplacementParent(cart.items[i])) return true;
    }

    var anyVisible = false;
    for (var j = 0; j < cart.items.length; j++) {
      if (!isHiddenLensLine(cart.items[j])) {
        anyVisible = true;
        break;
      }
    }
    if (anyVisible) return false;

    for (var k = 0; k < cart.items.length; k++) {
      if (getItemProperties(cart.items[k])._productType !== 'addon') return true;
    }

    return false;
  }

  function isHiddenLensLine(item) {
    if (!item) return false;
    if (isLensReplacementParent(item)) return false;
    if (item.vendor === 'LensAdvizor') return true;
    if (item.product_type === 'LensAdvizor') return true;
    var props = getItemProperties(item);
    if (props._productType === 'lens' || props._productType === 'addon') return true;
    return false;
  }

  function isLensLineNotAddon(item) {
    if (!isHiddenLensLine(item)) return false;
    return getItemProperties(item)._productType !== 'addon';
  }

  function countVisibleItems(cart) {
    if (!cart || !cart.items) return 0;
    var count = cart.items.reduce(function (sum, item) {
      if (isHiddenLensLine(item)) return sum;
      return sum + (item.quantity || 0);
    }, 0);
    if (count === 0 && cart.items.length > 0) {
      if (cartHasLensReplacementOrder(cart)) {
        return 1;
      }
    }
    return count;
  }

  function isContactLensLine(item) {
    if (!item) return false;
    if (item.product_type === 'Contact Lenses') return true;
    var props = getItemProperties(item);
    if (props.Eye || props._Eye) return true;
    var propKeys = Object.keys(props);
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      if (key.indexOf('Prescription Type') >= 0) {
        var val = String(props[key] || '');
        if (val.indexOf('Contact Lens') >= 0) return true;
      }
    }
    return false;
  }

  function collectLineKeysToRemove(cart, removedKey) {
    var keys = [removedKey];
    var items = (cart && cart.items) || [];
    var removedItem = items.find(function (item) {
      return item.key === removedKey;
    });
    if (!removedItem) return keys;

    if (isContactLensLine(removedItem)) {
      return keys;
    }

    var bundleId = getBundleId(removedItem);
    var removedIndex = items.findIndex(function (item) {
      return item.key === removedKey;
    });

    if (bundleId) {
      items.forEach(function (item) {
        if (item.key === removedKey) return;
        if (getBundleId(item) === bundleId && isHiddenLensLine(item)) {
          keys.push(item.key);
        }
      });
    }

    if (!isHiddenLensLine(removedItem) && removedIndex !== -1) {
      for (var i = removedIndex + 1; i < items.length; i++) {
        var nextItem = items[i];
        if (isLensLineNotAddon(nextItem)) {
          keys.push(nextItem.key);
          break;
        }
        if (!isHiddenLensLine(nextItem)) break;
      }
    }

    return keys.filter(function (key, index, list) {
      return list.indexOf(key) === index;
    });
  }

  function updateHeaderCartBubbles(count) {
    var safeCount = parseInt(count, 10);
    if (isNaN(safeCount) || safeCount < 0) safeCount = 0;

    document.querySelectorAll('.hp-header-cart-wrap').forEach(function (wrap) {
      var bubble = wrap.querySelector('.hp-header-cart__bubble');
      if (safeCount === 0) {
        if (bubble) bubble.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'hp-header-cart__bubble';
        bubble.innerHTML =
          '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        wrap.appendChild(bubble);
      }

      var countEl = bubble.querySelector('span[aria-hidden="true"]');
      if (countEl) countEl.textContent = safeCount < 100 ? String(safeCount) : '';
    });

    var legacyLink = document.getElementById('cart-icon-bubble');
    if (!legacyLink) return;

    var legacyBubble = legacyLink.querySelector('.cart-count-bubble');
    if (safeCount === 0) {
      if (legacyBubble) legacyBubble.remove();
      return;
    }

    if (!legacyBubble) {
      legacyBubble = document.createElement('div');
      legacyBubble.className = 'cart-count-bubble absolute !right-[2px] top-[4px] !left-[inherit]';
      legacyBubble.innerHTML =
        '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      legacyLink.appendChild(legacyBubble);
    }

    var legacyCount = legacyBubble.querySelector('span[aria-hidden="true"]');
    if (legacyCount) legacyCount.textContent = safeCount < 100 ? String(safeCount) : '';
  }

  function syncHeaderFromCart(cart) {
    updateHeaderCartBubbles(countVisibleItems(cart));
  }

  function cleanupOrphanHiddenLines() {
    if (window.__ciwOrphanCleanupRunning) return Promise.resolve();
    window.__ciwOrphanCleanupRunning = true;

    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        syncHeaderFromCart(cart);

        if (cartHasLensReplacementOrder(cart)) {
          var cartItemsEl = document.querySelector('cart-items');
          if (cartItemsEl) {
            cartItemsEl.classList.remove('is-empty');
            cartItemsEl.setAttribute('data-ciw-lr-order', '1');
          }
          var cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.remove('is-empty');
          return cart;
        }

        var visibleCount = countVisibleItems(cart);
        if (visibleCount > 0 || !cart.items || cart.items.length === 0) {
          return cart;
        }

        var orphanKeys = cart.items
          .filter(function (item) {
            return isHiddenLensLine(item);
          })
          .map(function (item) {
            return item.key;
          });

        if (!orphanKeys.length) return cart;

        if (orphanKeys.length >= cart.items.length) {
          return cart;
        }

        var changeUrl =
          (window.routes && window.routes.cart_change_url) || '/cart/change';
        var config =
          typeof fetchConfig === 'function'
            ? fetchConfig()
            : {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
              };
        var cartItemsEl = document.querySelector('cart-items');
        var sectionIds = [];
        if (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') {
          sectionIds = cartItemsEl
            .getSectionsToRender()
            .map(function (section) {
              return section.section;
            })
            .filter(Boolean);
        }

        return orphanKeys.reduce(function (chain, key, index) {
          return chain.then(function () {
            var payload = {
              id: key,
              quantity: 0,
            };
            if (index === orphanKeys.length - 1 && sectionIds.length) {
              payload.sections = sectionIds;
              payload.sections_url = window.location.pathname;
            }
            return fetch(
              changeUrl,
              Object.assign({}, config, {
                credentials: 'same-origin',
                body: JSON.stringify(payload),
              })
            ).then(function (response) {
              if (!response.ok) throw new Error('cart change failed');
              return response.text();
            }).then(function (state) {
              return JSON.parse(state);
            });
          });
        }, Promise.resolve()).then(function (finalCart) {
          syncHeaderFromCart(finalCart);
          if (
            cartItemsEl &&
            finalCart.sections &&
            typeof cartItemsEl.renderCartSections === 'function'
          ) {
            cartItemsEl.renderCartSections(finalCart);
            if (typeof cartItemsEl.isCartVisuallyEmpty === 'function') {
              var empty = cartItemsEl.isCartVisuallyEmpty(finalCart);
              cartItemsEl.classList.toggle('is-empty', empty);
              var cartFooter = document.getElementById('main-cart-footer');
              if (cartFooter) cartFooter.classList.toggle('is-empty', empty);
            }
          }
          if (
            typeof publish === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined'
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'ciw-cart-sync',
              cartData: finalCart,
            });
          }
          return finalCart;
        });
      })
      .catch(function () {})
      .finally(function () {
        window.__ciwOrphanCleanupRunning = false;
      });
  }

  window.CIW_CART_SYNC = {
    collectLineKeysToRemove: collectLineKeysToRemove,
    countVisibleItems: countVisibleItems,
    updateHeaderCartBubbles: updateHeaderCartBubbles,
    syncHeaderFromCart: syncHeaderFromCart,
    cleanupOrphanHiddenLines: cleanupOrphanHiddenLines,
    isHiddenLensLine: isHiddenLensLine,
    isLensReplacementParent: isLensReplacementParent,
    cartHasLensReplacementOrder: cartHasLensReplacementOrder,
    isContactLensLine: isContactLensLine
  };

  function bindCartUpdateListener() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (window.__ciwCartSyncBound) return;
    window.__ciwCartSyncBound = true;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || !event.cartData) return;
      // /cart/add.js returns a line item, not a full cart — badge needs .items
      if (!event.cartData.items) {
        cleanupOrphanHiddenLines();
        return;
      }
      syncHeaderFromCart(event.cartData);
    });
  }

  function bootCartSync() {
    bindCartUpdateListener();
    cleanupOrphanHiddenLines();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCartSync);
  } else {
    bootCartSync();
  }
})();
